import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const SALES_PERSON_VIDEO_REPORT_ID = `sales-person${VIDEO_CAMPAIGN_SUFFIX}`;
